import { render, staticRenderFns } from "./EditarEnvioInformacionModal.vue?vue&type=template&id=5c232a0f&"
import script from "./EditarEnvioInformacionModal.vue?vue&type=script&lang=ts&"
export * from "./EditarEnvioInformacionModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5c232a0f', component.options)
    } else {
      api.reload('5c232a0f', component.options)
    }
    module.hot.accept("./EditarEnvioInformacionModal.vue?vue&type=template&id=5c232a0f&", function () {
      api.rerender('5c232a0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EnvioInformacion/EditarEnvioInformacionModal.vue"
export default component.exports